import { MonoTypeOperatorFunction, timeout } from 'rxjs';

export const reattach = <T>(): MonoTypeOperatorFunction<T> => timeout(0);
